__turbopack_context__.v({
  "chosenFilters": "chosenFilters-module-scss-module__iTgS6a__chosenFilters",
  "eraseIcon": "chosenFilters-module-scss-module__iTgS6a__eraseIcon",
  "filter": "chosenFilters-module-scss-module__iTgS6a__filter",
  "icon": "chosenFilters-module-scss-module__iTgS6a__icon",
});
